"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRADER_NAME_MAX_LENGTH = exports.TRADER_NAME_MIN_LENGTH = void 0;
exports.TRADER_NAME_MIN_LENGTH = 4;
exports.TRADER_NAME_MAX_LENGTH = 100;
